import React from 'react';
import { updateIntercom } from 'next-intercom';

export const useHideIntercomLauncher = () => {
  React.useEffect(() => {
    updateIntercom('update', { hide_default_launcher: true });

    return () => updateIntercom('update', { hide_default_launcher: false });
  }, []);

  return null;
};
